import SuccessPage from "./successPage";
export default SuccessPage;
